import { ATP_API_URL } from "@config/apiconfig";
import apiClient from "@services/apiClient";

export const getAllVouchersList = async (payload = {}) => {
  try {
    let url = ATP_API_URL.GET_ALL_VOUCHER_DETAILS;

    const response = await apiClient.post(url, payload);

    if (response.data?.success) {
      return response.data;
    }

    return response?.data?.message || "Something went wrong, Please, try again";
  } catch (error) {
    throw error;
  }
};
